import LandingPageService from '@/services/LandingPageService.js'

export default {
  namespaced: true,
  state: {
    isLoadingLP: false,
    areas: {}
  },
  mutations: {
    SET_AREAS(state, areas) {
      state.areas = areas
    },
    SET_IS_LOADING(state, isLoading) {
      state.isLoadingLP = isLoading
    }
  },
  actions: {
    async fetchData({ commit }) {
      commit('SET_IS_LOADING', true)
      await LandingPageService.getData()
        .then(response => {
          commit('SET_IS_LOADING', false)
          commit('SET_AREAS', response)
        })
        .catch(error => {
          console.log('There was a problem fetching areas: ' + error.message)
          throw error
        })
    }
  }
}
